import React from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import './docs.css'

const Docs = (props) => {
  return (
    <div className="docs-container">
      <Helmet>
        <title>docs - Wapi: Unofficial Whatsapp Business Api</title>
        <meta
          name="description"
          content="Wapi is an unofficial WhatsApp Business API, It aims to provide an alternative solution for businesses looking to integrate WhatsApp's messaging capabilities into their operations"
        />
        <meta
          property="og:title"
          content="docs - Wapi: Unofficial Whatsapp Business Api"
        />
        <meta
          property="og:description"
          content="Wapi is an unofficial WhatsApp Business API, It aims to provide an alternative solution for businesses looking to integrate WhatsApp's messaging capabilities into their operations"
        />
      </Helmet>
      <header data-thq="thq-navbar" className="docs-navbar-interactive">
        <h1 className="docs-text">Wapi</h1>
        <div
          data-thq="thq-navbar-nav"
          data-role="Nav"
          className="docs-desktop-menu"
        >
          <nav
            data-thq="thq-navbar-nav-links"
            data-role="Nav"
            className="docs-nav"
          >
            <a href="/#features" className="docs-link">
              Features
            </a>
            <a href="/#pricing" className="docs-link1">
              Pricing
            </a>
          </nav>
        </div>
        <div data-thq="thq-navbar-btn-group" className="docs-btn-group">
          <Link to="/login" className="docs-login button">
            Login
          </Link>
          <Link to="/signup" className="docs-register button">
            Start Free Trial
          </Link>
        </div>
        <div data-thq="thq-burger-menu" className="docs-burger-menu">
          <svg viewBox="0 0 1024 1024" className="docs-icon">
            <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
          </svg>
        </div>
        <div data-thq="thq-mobile-menu" className="docs-mobile-menu">
          <div
            data-thq="thq-mobile-menu-nav"
            data-role="Nav"
            className="docs-nav1"
          >
            <div className="docs-container1">
              <h2>Wapi</h2>
              <div data-thq="thq-close-menu" className="docs-menu-close">
                <svg viewBox="0 0 1024 1024" className="docs-icon2">
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </div>
            </div>
            <nav
              data-thq="thq-mobile-menu-nav-links"
              data-role="Nav"
              className="docs-nav2"
            ></nav>
            <div className="docs-container2">
              <a
                href="/login"
                target="_blank"
                rel="noreferrer noopener"
                className="docs-login1 button"
              >
                Login
              </a>
              <a
                href="/signup"
                target="_blank"
                rel="noreferrer noopener"
                className="docs-register1 button"
              >
                Get Started For Free
              </a>
            </div>
          </div>
        </div>
      </header>
      <div className="docs-container3">
        <div className="docs-container4">
          <h3 className="docs-text2">
            <span>Explore Our Api Documentation </span>
            <br></br>
          </h3>
        </div>
        <div className="docs-container5">
          <button type="button" className="docs-button button">
            Download Postman Collection
          </button>
        </div>
        <div className="docs-container6">
          <img
            alt="image"
            src="/external/wapi_postman-1500w.jpg"
            className="docs-image"
          />
        </div>
      </div>
      <footer className="docs-footer">
        <div className="docs-container7">
          <span className="docs-text5">Email us at </span>
          <a
            href="mailto:admin@steksolutions.net?subject="
            className="docs-link2"
          >
            admin@steksolutions.net
          </a>
        </div>
        <div className="docs-separator"></div>
        <span className="docs-text6">© 2023 Wapi, All Rights Reserved.</span>
      </footer>
    </div>
  )
}

export default Docs
